"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionChip = PositionChip;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const useStyles_1 = require("~/useStyles");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    chip: {
        background: "#333",
        padding: "2px 4px",
        fontFamily: "ui-monospace, monospace",
        fontWeight: 500,
        color: "#fff",
        fontSize: "12px",
    },
}));
function PositionChip({ position, className }) {
    const classes = useStyles();
    return react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.chip, className) },
        "#",
        position);
}
